import { makeSlug } from '@trello/urls';

export const getNotificationCardShortUrl = (data: {
  card?: {
    shortLink?: string;
    idShort?: number;
    name?: string;
  };
}) => {
  const card = data.card;
  if (card) {
    return `/c/${card.shortLink}/${card.idShort}-${makeSlug(card.name || '')}`;
  } else {
    return '#';
  }
};
